import React from "react";
import { Box } from "@primer/react";

interface TrayDropdownProps {
  children: React.ReactNode;
}

export const TrayDropdown = React.forwardRef<HTMLDivElement, TrayDropdownProps>(
  ({ children }, ref) => (
    <Box
      ref={ref}
      style={{
        position: "absolute",
        top: "100%",
        right: 0,
        marginTop: "4px",
        minWidth: "280px",
        maxWidth: "400px",
        zIndex: 10,
        backgroundColor: "var(--bgColor-default, #ffffff)",
        borderRadius: "12px",
        boxShadow: "0 8px 24px rgba(140, 149, 159, 0.2)",
        border: "1px solid var(--borderColor-default, #d0d7de)",
        overflow: "hidden",
      }}
    >
      {children}
    </Box>
  )
);

TrayDropdown.displayName = "TrayDropdown";
